import dayjs from 'dayjs'
import type { BadgeColor } from '@firstbite/ui'
import { getDaysSinceColorClass } from 'utils/formatting'

/**
 * Map a day-count to the app-wide staleness color as an fb-ui `BadgeColor`
 * (fresh = success/green, aging = warning/amber, stale = error/red), using the
 * shared `getDaysSinceColorClass` thresholds so a record colors identically on
 * every entity detail header (deal, contact, …).
 */
export function freshnessColor(days: number): BadgeColor {
  switch (getDaysSinceColorClass(days, 'text')) {
    case 'text-warning':
      return 'warning'
    case 'text-error':
      return 'error'
    default:
      return 'success'
  }
}

/**
 * Same staleness color, derived from an ISO date string (days from that date to
 * now). Returns `undefined` for a missing date so callers can fall back.
 */
export function freshnessColorFromDate(
  date?: string | number | null
): BadgeColor | undefined {
  if (!date) return undefined
  return freshnessColor(dayjs().diff(dayjs(date), 'day'))
}
